import { SftpAuthType } from '../../enums/sftp-connectors/sftp-auth-type';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Base configuration shared by SftpReaderConfig and SftpWriterConfig.
 * Holds connection credentials and the remote directory/file filter.
 */
export abstract class SftpConnectorBase extends DestinationTaskConfigBase {
	/** Hostname or IP of the SFTP server. */
	host?: string;
	/** SFTP port. @default 22 */
	port = 22;
	/** Authentication method. Password=0, SSH=1. @default SftpAuthType.Password */
	authType = SftpAuthType.Password;
	/** SFTP username. */
	username?: string;
	/** SFTP password. Used when authType=Password. */
	password?: string;
	/** SSH private key content. Used when authType=SSH. */
	privateKey?: string;
	/** Passphrase for the SSH private key, if protected. */
	passphrase?: string;
	/** Remote directory path to read from or write to. */
	dir?: string;
	/** Glob pattern to match file names in the remote directory. @default '*.csv' */
	fileFilter = '*.csv';

	constructor(init?: Partial<SftpConnectorBase>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
